/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Score_Clarity_DescriptionInputs */

const en_score_clarity_description = /** @type {(inputs: Score_Clarity_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A resume should contain as few grammatical and/or spelling errors as possible. This shows recruiters that you wrote and proofread your resume carefully. That is exactly what they will also expect from your work results. Even if you are not a native speaker, there are now plenty of tools that can correct errors.`)
};

const de_score_clarity_description = /** @type {(inputs: Score_Clarity_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Lebenslauf sollte möglichst keine grammatikalischen und / oder Rechtschreibfehler enthalten. Das zeigt Recruitern, dass du den Lebenslauf sorgfältig geschrieben und Korrektur gelesen hast. Genau das erwarten sie auch bei deinen Arbeitsergebnissen. Auch wenn du Nicht-Muttersprachler*in bist, gibt es mittlerweile ausreichend Tools, die Fehler korrigieren können.`)
};

/**
* | output |
* | --- |
* | "A resume should contain as few grammatical and/or spelling errors as possible. This shows recruiters that you wrote and proofread your resume carefully. That..." |
*
* @param {Score_Clarity_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const score_clarity_description = /** @type {((inputs?: Score_Clarity_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Score_Clarity_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_score_clarity_description(inputs)
	return en_score_clarity_description(inputs)
});